import { ServiceResponse } from "../ServiceResponse";

export class SendVerificationCodeResponse extends ServiceResponse {
}
